import http from 'axios'
import { Message } from 'view-design'
import { formatQuery, deleteUseless } from '../../lib/formatParams/index'

export default {
  namespaced: true,
  state: {
    accountInfo: {}
  },
  actions: {
    // 检查机构是否实名认证 0未审核1未通过 2通过 404未提交实名认证资料
    CheckUnionCertification({ commit, state }) {
      return new Promise((resolve, reject) => {
        http.get("/v1/promoter/CheckUnionCertification")
          .then(({ data }) => {
            if (data.s === 10006) {
              commit("updataAccountInfo", data.list)
              resolve(data)
            } else {
              reject(data)
            }
          })
          .catch(error => {
            console.log(error)
            Message.error(error.msg)
            reject(error)
          })
      })
    },
    // 查看账户信息
    LookUnionUserInfo({ state }) {
      return new Promise((resolve, reject) => {
        http.get("/v1/promoter/LookUnionUserInfo")
          .then(({ data }) => {
            if (data.s === 10006) {
              resolve(data)
            } else {
              reject(data)
            }
          })
          .catch(error => {
            console.log(error)
            reject(error)
          })
      })
    },
    // 查看银行卡号验证
    CheckSmsCodeByChangeBankNo({ state }, params) {
      return new Promise((resolve, reject) => {
        http.get("/v1/register/CheckSmsCodeByChangeBankNo" + formatQuery(params))
          .then(({ data }) => {
            if (data.s === 10006) {
              resolve(data)
            } else {
              reject(data)
            }
          })
          .catch(error => {
            console.log(error)
            reject(error)
          })
      })
    },
    // 修改银行卡信息
    ChangeBankNoBySmsCode({ state }, params) {
      return new Promise((resolve, reject) => {
        http.post("/v1/promoter/ChangeBankNoBySmsCode", deleteUseless(params))
          .then(({ data }) => {
            if (data.s === 10006) {
              resolve(data)
            } else {
              reject(data)
            }
          })
          .catch(error => {
            console.log(error)
            reject(error)
          })
      })
    },
    // 查看身份证
    LookCardNo({ state }) {
      return new Promise((resolve, reject) => {
        http.get("/v1/promoter/LookCardNo")
          .then(({ data }) => {
            if (data.s === 10006) {
              resolve(data)
            } else {
              reject(data)
            }
          })
          .catch(error => {
            console.log(error)
            reject(error)
          })
      })
    },
    // 查看银行卡
    LookBankCard({ state }) {
      return new Promise((resolve, reject) => {
        http.get("/v1/promoter/LookBankCard")
          .then(({ data }) => {
            if (data.s === 10006) {
              resolve(data)
            } else {
              reject(data)
            }
          })
          .catch(error => {
            console.log(error)
            reject(error)
          })
      })
    },
    // 修改密码（验证旧密码进行修改
    ChangeUnionPwd({ state }, params) {
      return new Promise((resolve, reject) => {
        http.post("/v1/resetpassword/ChangeUnionPwd", params)
          .then(({ data }) => {
            if (data.s === 10006) {
              resolve(data)
            } else {
              reject(data)
            }
          })
          .catch(error => {
            console.log(error)
            reject(error)
          })
      })
    },
    // 修改个人信息
    UpdateUnionInfo({ dispatch }, params) {
      return new Promise((resolve, reject) => {
        http.post("/v1/promoter/UpdateUnionInfo", params)
          .then(({ data }) => {
            if (data.s === 10006) {
              dispatch("CheckUnionCertification")
              resolve(data)
            } else {
              reject(data)
            }
          })
          .catch(error => {
            console.log(error)
            reject(error)
          })
      })
    },
    // 修改手机绑定验证
    UpdateMobileBindCheckCode({ state }, params) {
      return new Promise((resolve, reject) => {
        http.post("/v1/promoter/UpdateMobileBindCheckCode", params)
          .then(({ data }) => {
            if (data.s === 10006) {
              resolve(data)
            } else {
              reject(data)
            }
          })
          .catch(error => {
            console.log(error)
            reject(error)
          })
      })
    },
    // 新手机绑定机构
    UpdateMobileBind({ dispatch }, params) {
      return new Promise((resolve, reject) => {
        http.post("/v1/promoter/UpdateMobileBind", params)
          .then(({ data }) => {
            if (data.s === 10006) {
              dispatch("CheckUnionCertification")
              resolve(data)
            } else {
              reject(data)
            }
          })
          .catch(error => {
            console.log(error)
            reject(error)
          })
      })
    }
  },
  mutations: {
    updataAccountInfo(state, params) {
      state.accountInfo = params
    }
  },
  getters: {
    accountInfo(state) {
      return state.accountInfo
    }
  }
}